import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./Screens/Home/Home";
import About from "./Screens/About/About";
import Navbar from "./Components/Navbar/Navbar";
import "./App.css";
import Footer from "./Components/Foorter/Footer";
import WhyZlipp from "./Screens/WhyZlipp/WhyZlipp";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import Download from "./Screens/Download/Download";

function AppLayout() {
  const { pathname } = useLocation();
  const isDownloadPage = pathname === "/download";

  return (
    <>
      {!isDownloadPage && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/whyzlipp" element={<WhyZlipp />} />
        <Route path="/download" element={<Download />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      {!isDownloadPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
